// Cabeçalho do Portal do Consumidor — antes repetido (copiado/colado) em cada tela, cada
// uma com um jeito ligeiramente diferente. Extraído para não desalinhar de novo (foi o que
// aconteceu: só a Home tinha o link "Meu Perfil").
import React from 'react';
import { Link } from 'react-router-dom';
import { LogOut, UserCircle } from 'lucide-react';
import { useAuth } from '../../src/contexts/AuthContext';
import LogoMarcaPortal from './marca/LogoMarcaPortal';

const PortalConsumidorHeader: React.FC = () => {
    const { signOut } = useAuth();

    return (
        <header className="bg-white border-b border-gray-200 sticky top-0 z-40">
            <div className="max-w-5xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <LogoMarcaPortal />
                    <span className="hidden sm:inline text-sm font-semibold text-gray-400 border-l border-gray-200 pl-3">
                        Portal do Consumidor
                    </span>
                </div>
                <div className="flex items-center gap-4">
                    <Link
                        to="/portal-consumidor/perfil"
                        className="flex items-center gap-2 text-sm font-medium text-gray-500 hover:text-primary transition-colors"
                    >
                        <UserCircle size={18} />
                        <span className="hidden sm:inline">Meu Perfil</span>
                    </Link>
                    <button
                        onClick={signOut}
                        className="flex items-center gap-2 text-sm font-medium text-gray-500 hover:text-red-600 transition-colors"
                    >
                        <LogOut size={16} />
                        Sair
                    </button>
                </div>
            </div>
        </header>
    );
};

export default PortalConsumidorHeader;
